<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <h2 class="pg_title">Service Bulletin - Mobile (English) Create</h2>
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            Date
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="create.REG_DT"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>
                            Register
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="create.REG_USER_ID"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Type
                            <em class="txt_mandatory">*</em>

                        </th>
                        <td>
                            <select
                                class="slt_white w100p"
                                v-model="create.TYPE1"
                                @change="create.TYPE2 = ''"
                            >
                                <option value="Guide">Guide</option>
                                <option value="Bulletin">Bulletin</option>
                            </select>
                        </td>
                        <th>Subtype
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <select
                                class="slt_white w100p"
                                ref="TYPE2G"
                                v-if="create.TYPE1 === 'Guide'"
                                v-model="create.TYPE2"
                                v-validation
                            >
                                <option value>Select Inquiry type</option>
                                <option value="Common">Common</option>
                                <option value="IMEI">IMEI</option>
                                <option value="Policy / Process">Policy / Process</option>
                                <option value="SW Tool">SW Tool</option>
                                <option value="Jig / Equipment">Jig / Equipment</option>
                                <option value="Training Material">Training Material</option>
                            </select>

                            <div v-if="create.TYPE1 === 'Bulletin'" >
                                <select
                                    class="slt_white w49"
                                    ref="TYPE2B"
                                    v-model="create.TYPE2"
                                >
                                    <option value>Select Inquiry type</option>
                                    <option
                                        v-for="item in bulletinType2List"
                                        :key="item"
                                        :value="item"
                                    >{{item}}</option>
                                </select>
                                <input
                                    class="text_input w49"
                                    type="text" v-model="create.NTYPE2">
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <th>
                            Urgency
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="N" v-model="create.URGENCY_YN" />
                                <i class="radio-icon"></i>
                                <em>Normal</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="Y" v-model="create.URGENCY_YN" />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Urgency</em>
                            </label>
                        </td>
                        <th>
                            Need Translation
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="Y" v-model="create.NEED_REPROCESS" />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Need</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="N" v-model="create.NEED_REPROCESS" />
                                <i class="radio-icon"></i>
                                <em>Not Need</em>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Title
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="title"
                                    minlength="5"
                                    maxlength="200"
                                    v-model="create.TITLE"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    minlength="2"
                                    maxlength="200"
                                    v-model="create.TAG_INFO"
                                    value
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            User Level
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <!--User Levec heckbox-->
                            <!--checkbox_all-->
                            <div class="check_wrap w260p">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxUserLevelAll"
                                        @change="onUserLevelAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div
                                class="check_wrap w260p"
                                v-for="item in userLevelList"
                                :key="item.CODE_ID"
                            >
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        :value="item.CODE_ID"
                                        @change="onUserLevelCheckboxChange($event)"
                                        v-model="checkedUserLevelList"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>{{item.CODE_ID}}({{item.CODE_NAME}})</em>
                            </div>
                            <!--//User Level checkbox-->
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Subsidary
                            <em class="txt_mandatory">*</em>
                            <span class="ico_pen" @click="selectSubsidiaryPopup">pen아이콘</span>
                        </th>
                        <td colspan="3">
                            <ul class="ul_list">
                                <li
                                    class="userlevel_txt"
                                    v-for="item in selectedSubsidiaryList"
                                    :key="item"
                                >{{item}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Country / Region
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <div
                                v-if="availableCountryList.length === 0"
                            >Please select subsidiary first.</div>
                            <div class="check_wrap w260p" v-if="availableCountryList.length > 0">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxCountryAll"
                                        @change="onCountryAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div class="max_scrollbar">
                                <div
                                    class="check_wrap w260p"
                                    v-for="item in availableCountryList"
                                    :key="item.CODE_ID"
                                >
                                    <label class="checkbox-wrap mr5">
                                        <input
                                            type="checkbox"
                                            :value="item.CDCODE"
                                            @change="onCountryCheckboxChange($event)"
                                            v-model="checkedCountryList"
                                        />
                                        <i class="check-icon"></i>
                                    </label>
                                    <em>{{item.CDDESC}}</em>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Contents
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <cross-editor editorId="bulletin" :editorData="create.CONTENT" />
                        </td>
                    </tr>
                    <tr>
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                              <innorix-upload
                                :id="getUploadId"
                                :name="getUploadId"
                                :uploadId="getUploadId"
                                :onlyUpload="onlyUpload"
                                :attachList="attachFileSeq"
                                @files="setAttachFiles"
                            /> 
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a
                    href="javascript:"
                    class="btn_white"
                    @click="$router.push({name: 'hhpServiceBulletin'})"
                >List</a>
                <div class="btn_right">
                 	<a href="javascript:" class="btn_white" @click="btnSaveDraft()">{{ $t('BUTTON.GLOBAL.SAVEDRAFT') }}</a>
                    <a href="javascript:" class="btn_blue" @click="onSaveClick()">Save</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue            from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';

import AnysvcApprovalPopup        from '~c/popup/AnysvcApprovalPopup';
import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';
import KnowledgeTargetPopup from '~vb/knowledge/popup/KnowledgeTargetPopup';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';


export default {
    name: '',
    components: {
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: {},
    computed: {
        getGuid() {
            if (SDLUtil.isNull(this.guid)) {
                this.guid = StringUtil.guid();
            }
            return this.guid;
        },
        getEditorId() {
            if (SDLUtil.isNull(this.editorId)) {
                this.editorId = 'ce_' + this.getGuid;
            }
            return this.editorId;
        },
        getUploadId() {
            if (SDLUtil.isNull(this.uploadId)) {
                this.uploadId = 'inno_' + this.getGuid;
            }
            return this.uploadId;
        },
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            allUserLevelList: [],

            userLevelList: [],
            subsidiaryList: [],
            bulletinType2List: [],

            selectedSubsidiaryList: [],

            create: {
                REG_DT: '',
                REG_USER_ID: '',
                URGENCY_YN: 'N',
                NEED_REPROCESS: 'Y',
                TYPE1: 'Guide',
                TYPE2: '',
                NTYPE2: '',
                CONTENT: '',
                TITLE: '',
                TAG_INFO: '',
                SEQ: '',
            },
            checkedUserLevelList: [],

            availableCountryList: [],
            checkedCountryList: [],

            guid: '', // 임의의 guid
            editorId: '', // CE id
            uploadId: '', // Innorix id
            onlyUpload: false, // Innorix upload only check

            attachFileSeq: [], // Attach files
            delAttachFiles: [], // Delete attach files
            isRemove: false, // Attach remove flag
            
            // save 이후 seq 리턴
            seq: '',           // seq
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);

            this.create.REG_USER_ID = SDLUtil.getLoginedUserInfo().loginId;

            const dateFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            this.create.REG_DT = moment().formatWithJDF(dateFormat);

            const data = await this.fetchInitData();
            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Initial Loading Error',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }
            console.log('Init data', data);
            this.setInitData(data);
            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbRegister.skp`)
                    .then(res => {
                        return res.data;
                    })
                    .catch(err => {
                        console.log(`SvcBulletin ERROR =>>`, err);
                        return err.data;
                    })
            );
        },
        setInitData(data) {
            this.userLevelList = data.userLevelList;
            this.allUserLevelList = data.userLevelList.map(item => item.CODE_ID);
            this.subsidiaryList = data.subsidiaryList;
            this.bulletinType2List = data.bulletinType2List.map(item => item.TYPE2);
        },

        fetchAvailableCountryList() {
            const subsidiary = this.selectedSubsidiaryList
                .map(name => {
                    return this.subsidiaryList.find(item => item.SUBSIDIARY_NM === name).SUBSIDIARY_CD;
                })
                .join(',');

            const params = { subsidiary };
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/notice/countryBySubsidiary.skp`, { params })
                .then(res => res.data)
                .catch(err => err.data);
        },

        // 임시저장, 등록 시, validation 후 오브젝트 생성
        setContParamObj(type = 'draft') {
            let that = this,    // return 이후 scope가 변경되므로 that 으로 this 상태 저장
                isRegister = ( ['register', 'reprocess'].includes(type) ? true : false );

                // Default parameters
                let params = {
                    result              : true,
                    seq					: that.seq, 
                };
        },

        onSaveClick() {
            this.save('save');
        },
        
        btnSaveDraft(){
        	this.save('draft');
        },

        
        sendRequest(type){
        	const formData = this.prepFormData();
        	if(this.checkType1andType2()){
        		if (!this.validateInput()) return;   // 왜 화면이 로딩만 되나. 
        		formData.CHANGE_TYPE= 'update';
        	} else {
        		if(type === 'save'){
        			if (!this.validateInput()) return;   // 왜 화면이 로딩만 되나. 
        			formData.STATUS = 'S';
    				formData.CHANGE_TYPE = 'save';
        		}
        		if(type === 'draft'){
        			formData.STATUS = 'P';
    				formData.CHANGE_TYPE= 'draft';
        		}
        	}
        	if(!StringUtil.isNull(this.seq)) {
        		formData.seq=this.seq;
        		const  api = '/basis/anysvcmobile/svcBulletin/sbModifyProc.skp';
                return SDLUtil.postForm(api, formData);
            }else{
            	const	api = '/basis/anysvcmobile/svcBulletin/sbRegisterProc.skp';
            	return SDLUtil.postForm(api, formData);
            }
        },

        
        
        async save(type) {
        	let that = this; 
        	
           	
       		 
            const formData = this.prepFormData();
            SDLUtil.showLoadingBar(true);
            const reqData = await this.sendRequest(type);

           
            
            SDLUtil.showLoadingBar(false);
                            
            if (SDLUtil.isErrorResponse(reqData)) {
                SDLUtil.alert({
                    title: 'Error while Saving!',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }
            else {
            	this.create.SEQ = reqData.seq;
            	this.seq = reqData.seq;
            	
            	// 등록 후 결재 실행
            	if((this.checkType1andType2()) && (type === 'save')){
            			this.approvalPop();
            	} else {
            		this.$router.push({name: 'hhpServiceBulletin'});
            		}
            	}
        },

        // 결재 팝업  ( Knowledge 부분을 가져다가 사용해 보자. ) 
        approvalPop() {
        	let that = this;
            // 결재 사용 여부 확인 (단, SCMS 컨텐츠 작성은 무조건 결재를 한다.)
            //if(this.verifyUseYn || this.isSCMSDirect) {
            		// 결재 팝업 오픈
                    SDLUtil.show(
                        AnysvcApprovalPopup,
                        {
                            
                            title:           that.create.TITLE, 
                            guideType:       'ALL',  //  A: 로 하드코딩. 
                            prdCategoryCd1:  'D',  // D: Mobile,  B: Computer   
                            // service  bulletin approvel
                            serviceBulletinYn: 'SB',
                            workTable:       'ANYSVC_KNOWLEDGE',
                            workColumn:      'SEQ',
                            //workKey:         that.KNOWLEDGE_ID,  // EDIT ( 수정할때 필요할듯 )   처음 등록이라면 선 저장 후 결재 해야 할듯 ...  regAddContents 참조 
                            workKey:         that.seq,  // 결재 테이블에 키값 연결 
                           
                        },
                        { height: 'auto' }
                    );
           
        },
        
        validateInput() {
            if (this.create.TYPE1 === 'Bulletin' && !this.create.TYPE2 && !this.create.NTYPE2) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a subtype.',
                    onOkEvt: () => {
                        if (this.create.TYPE1 === 'Guide') {
                            this.$refs.TYPE2G.focus();
                        } else {
                            this.$refs.TYPE2B.focus();
                        }
                    },
                });
                return false;
            }

            if (this.create.TYPE1 === 'Guide' && !this.create.TYPE2) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a subtype.',
                    onOkEvt: () => {
                        if (this.create.TYPE1 === 'Guide') {
                            this.$refs.TYPE2G.focus();
                        } else {
                            this.$refs.TYPE2B.focus();
                        }
                    },
                });
                return false;
            }

            if (!this.create.TITLE.trim() || this.create.TITLE.length < 5) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Title is required.',
                    onOkEvt: () => this.$refs.title.focus(),
                });
                return false;
            }

            if (this.checkedUserLevelList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 user level needs to be selected.',
                });
                return false;
            }

            if (this.checkedCountryList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 country needs to be selected.',
                });
                return false;
            }
            return true;
        },

        prepFormData() {
            console.log('subList', this.selectedSubsidiaryList);
            const countryCodeList = this.selectedSubsidiaryList;

            const CEblankTxt = '<p><br></p>';
            const content = window.bulletin.GetBodyValue();
            if (content === CEblankTxt) {
                //invalid
            }
			console.log(this)
            const params = {
                TITLE: this.create.TITLE,
                TYPE1: this.create.TYPE1,
                TYPE2: this.create.TYPE2,
                TAG_INFO: this.create.TAG_INFO,
                URGENCY_YN: this.create.URGENCY_YN,
                REG_USER_ID: this.create.REG_USER_ID,
                REG_DT: this.create.REG_DT,
                // SUBSIDIARY: this.create.,
                COUNTRY_VALUE_SPLIT: this.checkedCountryList.join(','),
                COUNTRY_TEXT_SPLIT: this.checkedCountryList
                    .map(code => this.availableCountryList.find(country => country.CDCODE === code).CDDESC)
                    .join(','),
                USER_LEVEL_SPLIT: this.checkedUserLevelList.join(','),
                NEED_REPROCESS: this.create.NEED_REPROCESS,
                CONTENT: content,
                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                //seq: this.create.seq,
                STATUS:'P',
            };

            if (this.create.TYPE1 === 'Bulletin' && this.create.NTYPE2 !== '') {
                params.TYPE2 = this.create.NTYPE2;
            }

            return params;
        },

        submit(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbRegisterProc.skp', formData)
                .then(res => {
                    console.log('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        selectSubsidiaryPopup() {
            SDLUtil.show(
                KnowledgeTargetPopup,
                {
                    selTargetList: this.selectedSubsidiaryList,
                    rtnFunc: this.onSelectSubsidiaryList,
                },
                { height: 'auto' },
            );
        },

        async onSelectSubsidiaryList(list = []) {
            // Subsidiary Target popup 에서 받아온 리스트를 sort 하여 답는다.
            this.selectedSubsidiaryList = list.sort();
            const data = await this.fetchAvailableCountryList();
            this.availableCountryList = data.countryList;
            console.log('countryList', this.availableCountryList);
        },

        onUserLevelAllCheckboxChange(e) {
            console.log('change e', e);
            this.checkedUserLevelList = e.target.checked ? this.allUserLevelList : [];
        },
        onCountryAllCheckboxChange(e) {
            console.log('change e', e);
            this.checkedCountryList = e.target.checked ? this.availableCountryList.map(item => item.CDCODE) : [];
        },
        onUserLevelCheckboxChange(e) {
            this.$refs.checkboxUserLevelAll.checked =
                this.checkedUserLevelList.length == this.allUserLevelList.length ? true : false;
        },
        onCountryCheckboxChange(e) {
            this.$refs.checkboxCountryAll.checked =
                this.checkedCountryList.length == this.availableCountryList.length ? true : false;
        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixUpload.vue -> BulletinCreate.vue / files : ', val);
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
      //Check whether submission is required for approval
    	checkType1andType2(){
    		if(this.create.TYPE1=== 'Guide' && (this.create.TYPE2 ==='Common'  || this.create.TYPE2 ==='IMEI' || this.create.TYPE2 ==='SW Tool' || this.create.TYPE2 ==='Jig / Equipment' || this.create.TYPE2 ==='Training Material')){
    			return false;
    		} else {
    			return true;
    		}
    	},
    },  	
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinCreate.vue